import { render } from "./WordDisplay.vue?vue&type=template&id=b92c06a0"
import script from "./WordDisplay.vue?vue&type=script&lang=js"
export * from "./WordDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__